import { RoundedStatusBadge } from "../../../../components/RoundedStatusBadge/RoundedStatusBadge";

interface CacheTypeTagProps {
  type: string | null;
}

export const cacheTypeMap: Record<string, string> = {
  public: "",
  "no-store": "Cache store disabled",
  "no-cache": "Cache disabled",
  "only-if-cached": "LLM disabled",
};

const CacheTypeTag: React.FC<CacheTypeTagProps> = ({ type }) => {
  return type && cacheTypeMap[type] ? (
    <RoundedStatusBadge>{cacheTypeMap[type]}</RoundedStatusBadge>
  ) : null;
};

export { CacheTypeTag };
